var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('StackedChart',{attrs:{"hcTitle":_vm.title,"hcSubtitle":_vm.subtitle,"hcData":_vm.seriesData,"AxisCategories":_vm.categories,"xAxisTitle":null,"yAxisTitle":"Y-Axis"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }